import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ui-worksheet',
  templateUrl: './ui-worksheet.component.html',
  styleUrls: ['./ui-worksheet.component.scss']
})
export class UiWorksheetComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
